import { useState } from 'react';

import ArrowSVG from '../../../../components/svg/ChevronRight.svg';
import MagnifierGlassSVG from '../../../../components/svg/MagnifierGlass.svg';
import RainbowSVG from '../../../../components/svg/Rainbow.svg';
import { useIsMobile } from '../../../../hooks/useIsMobile';
import { SellerInnerPageTemplate } from '../../../../routing/templates';
import { ExploreIntegrationsButton } from '../../components/ExploreIntegrationsButton/ExploreIntegrationsButton';
import { IntegrationButton } from '../../components/IntegrationButton/IntegrationButton';
import { integrationsList } from '../../Integrations';
import { IntegrationsHeader } from '../IntegrationsHeader/IntegrationsHeader';

export function IntegrationsDashboard() {
  const [integrationListOpen, setIntegrationListOpen] =
    useState<boolean>(false);

  const integrationButtonHandleClick = () => {
    setIntegrationListOpen(false);
  };

  const integrationListHandleClick = () => {
    setIntegrationListOpen(!integrationListOpen);
  };

  const { isMobile } = useIsMobile();

  return (
    <SellerInnerPageTemplate title="Integrations">
      <div className="flex h-full flex-col items-center justify-center text-primary-10">
        <IntegrationsHeader />
        {!isMobile && (
          <div className="flex w-full pt-[60px]">
            <div className="flex-[0_0_300px] border-r border-structure-80 pr-[40px] max-800:w-full max-800:flex-[0] max-800:border-r-0 max-800:pt-[2.25rem] max-1024:flex-[0_0_250px] max-1024:p-0">
              {integrationsList.map((integration) => (
                <IntegrationButton
                  integration={integration}
                  handleClick={integrationButtonHandleClick}
                  key={`${integration.company_name}__button-desktop`}
                />
              ))}
              <IntegrationBanners />
            </div>
            <div className="w-full pl-[40px]">
              {integrationsList.map((integration) => (
                <integration.body
                  key={`${integration.company_name}__body-desktop`}
                />
              ))}
            </div>
          </div>
        )}
        {isMobile && (
          <div className="flex w-full pt-[60px] max-800:flex-col">
            <div className="w-full border-b border-structure-80 pb-[36px]">
              <ExploreIntegrationsButton
                integrationListOpen={integrationListOpen}
                handleClick={integrationListHandleClick}
              />
            </div>
            {integrationListOpen && (
              <div className="flex-[0_0_300px] border-r border-structure-80 pr-[40px] max-800:w-full max-800:flex-[0] max-800:border-r-0 max-800:pt-[2.25rem] max-1024:flex-[0_0_250px] max-1024:p-0">
                {integrationsList.map((integration) => (
                  <IntegrationButton
                    integration={integration}
                    handleClick={integrationButtonHandleClick}
                    key={`${integration.company_name}__button-mobile`}
                  />
                ))}
              </div>
            )}
            {integrationsList.map((integration) => (
              <integration.body
                key={`${integration.company_name}__body-mobile`}
              />
            ))}
            <IntegrationBanners />
          </div>
        )}
      </div>
    </SellerInnerPageTemplate>
  );
}

const IntegrationBanners = () => {
  return (
    <div className="pt-xl text-s font-reg text-primary-10 max-600:mt-3xl">
      <div className="mb-l rounded-s border border-secondary-90 bg-primary-95 p-xl text-left last:mb-0">
        <img
          src={MagnifierGlassSVG}
          width="48"
          height="48"
          alt=""
          className="pb-m"
        />
        <h3 className="m-0 text-l font-bold">
          Can't find what you're looking for?
        </h3>
        <p className="my-m">
          Let us know what integration you'd like to see next.
        </p>
        <div className="flex">
          <a
            href="https://forms.gle/ut8sVsFTRuTWWpbR9"
            target="_blank"
            className="m-0 text-s font-bold text-primary-40 no-underline hover:underline"
            rel="noreferrer"
          >
            Request a new integration
          </a>
          <img src={ArrowSVG} width="20" height="20" alt="" />
        </div>
      </div>
      <div className="mb-l rounded-s border border-secondary-90 bg-core-95 p-xl text-left last:mb-0">
        <img src={RainbowSVG} width="48" height="48" alt="" className="pb-m" />
        <h3 className="m-0 text-l font-bold">Want something bespoke?</h3>
        <p className="my-m">
          If you’re looking for an automated lending solution for customers on
          your online store, we have an API.
        </p>
        <div className="flex">
          <a
            href="https://www.iwoca.co.uk/ecom/docs/"
            className="m-0 text-s font-bold text-primary-40 no-underline hover:underline"
            target="_blank"
            rel="noreferrer"
          >
            See our API docs
          </a>
          <img src={ArrowSVG} width="20" height="20" alt="" />
        </div>
      </div>
    </div>
  );
};
